import {useQuery} from "react-query";
import queryKeys from "./queryKeys";
import getPromise from "./getPromise";

const prefix_url = "/address";

export const useAddressAllFetch = (animal_location_city={})=>{
    return useQuery([queryKeys.ADDRESS_ALL, animal_location_city], () => getPromise(prefix_url, {animal_location_city}));
}
